import React from 'react';
import './App.css';
import AuthProvider from 'components/Auth/AuthProvider';
import { DefaultLayout } from 'components/Layouts/DefaultLayout';
import Login from 'components/Login';
import { Route, Routes } from 'react-router-dom';
import Home from 'components/Home';
import { NotFound } from 'components/NotFound';
import SecureUpload from 'components/SecureUpload';
import AllUploads from 'components/Uploads/All';
import AllAccesses from 'components/Access/All';
import WideLayout from 'components/Layouts/WideLayout';
import RequireAuth from 'components/Auth/RequireAuth';
import AllUsers from 'components/Users/All';

const AdminRoutes = () => (
  <Routes>
    <Route
      path="*"
      element={(
        <WideLayout>
          <Routes>
            <Route path="access" element={<AllAccesses />} />
            <Route path="users" element={<AllUsers />} />
            <Route path="uploads/:accessToken" element={<AllUploads />} />
          </Routes>
        </WideLayout>
  )}
    />
  </Routes>
);

const DefaultRoutes = () => (
  <Routes>
    <Route
      path="*"
      element={(
        <DefaultLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/upload" element={<SecureUpload />} />
            <Route path="/upload/:uploadToken" element={<SecureUpload />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>

        </DefaultLayout>
)}
    />
  </Routes>
);

const App = () => (
  <AuthProvider>
    <Routes>
      <Route
        path="/admin/*"
        element={
          <RequireAuth adminOnly><AdminRoutes /></RequireAuth>
        }
      />
      <Route path="/*" element={<DefaultRoutes />} />
    </Routes>
  </AuthProvider>
);

export default App;
